module.exports = __webpack_public_path__ + "img/DDLRLOC.b644671a.svg";